import { render } from "./MvCoupon.vue?vue&type=template&id=4fec93c2&scoped=true"
import script from "./MvCoupon.vue?vue&type=script&lang=js"
export * from "./MvCoupon.vue?vue&type=script&lang=js"

import "./MvCoupon.vue?vue&type=style&index=0&id=4fec93c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec93c2"]])

export default __exports__